import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-beak-customer',
  templateUrl: './beak-customer.component.html',
  styleUrls: ['./beak-customer.component.css']
})
export class BeakCustomerComponent implements OnInit {

  formModel:any;
  submitted:boolean = false;
  loading:boolean = false;

  customerId:string;

  constructor(private router:Router, private route:ActivatedRoute) { }

  ngOnInit(): void {
    // console.log(this.router.url);
    // console.log(this.route.data);
    this.route.paramMap.subscribe((value)=>{
      this.customerId = value.get("userID")
      // console.log(this.customerId,value);
    },
    (error)=>{

    }
    )
  }

  onSubmit(){
    
  }

  onClose(){

  }

}
